import { atomFamily } from 'recoil'

import type { AsyncTaskState } from 'Hooks/useAsyncTask/types'

export const asyncTaskState = atomFamily<AsyncTaskState, string>({
  key: 'asyncTaskState',
  default: {
    status: 'initial',
    loading: false,
    //
    idTask: undefined,
    pollingIteration: 0,
  },
})

//  const { Status, Metadata } = await getTaskDetails(idTask)
